import React, { FC } from 'react';

import { cn, ClassName } from '../../utils';
import styles from './index.module.scss';


type Alignment = 'top' | 'right' | 'bottom' | 'left';
type TransformParentFn = (position: number, offset: number) => string;

const popupTransformMap: { [KAlignment in Alignment]: TransformParentFn } = {
    top: (position, offset) => `translate(${-position * 100}%, -100%) translateY(${-0.8 - offset}rem)`,
    right: (position, offset) => `translateY(${-position * 100}%) translateX(${0.8 + offset}rem)`,
    bottom: (position, offset) => `translateX(${-position * 100}%) translateY(${0.8 + offset}rem)`,
    left: (position, offset) => `translate(-100%, ${-position * 100}%) translateX(${-0.8 - offset}rem)`,
};

const popupStyle = (alignment: Alignment, position: number, offset: number) => ({
    transform: popupTransformMap[alignment](position, offset),
});

const alignmentToMarkerPosition = {
    top: 'left',
    right: 'top',
    bottom: 'left',
    left: 'top',
};

const markerStyle = (alignment: Alignment, position: number) => ({
    [alignmentToMarkerPosition[alignment]]: `${position * 100}%`,
});

export type InPlacePopupProps = ClassName & {
    alignment: Alignment;
    position?: number;
    offset?: number;
    style?: object;
};

export const InPlacePopup: FC<InPlacePopupProps> = ({
    className,
    children,
    alignment,
    position = 0.5,
    offset = 0,
}) => (
    <div className={cn(styles.inPlacePopup, styles[`inPlacePopup_${alignment}`], className)}>
        <div style={popupStyle(alignment, position, offset)}>
            <div className={styles.background} />
            <div
                className={cn(styles.marker, styles[alignment])}
                style={markerStyle(alignment, position)}
            />
            {children}
        </div>
    </div>
);
